import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vueSmoothScroll from 'vue2-smooth-scroll'

import 'bootstrap'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/lib/fontawesome4/css/font-awesome.min.css';
import './assets/css/style.css';

Vue.config.productionTip = true

Vue.use(vueSmoothScroll)
Vue.use(VueAxios, axios)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
